// extracted by mini-css-extract-plugin
export default {"teamStat":"TeamStat_teamStat__NenAN","name":"TeamStat_name__Pav7V","info":"TeamStat_info__yB3+A","columns11":"TeamStat_columns11__xanDS","padding":"TeamStat_padding__jD2Hs"};